import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

function readFirebaseConfig() {
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY || "";
  const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "";
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "";
  const appId = process.env.REACT_APP_FIREBASE_APP_ID || "";
  return { apiKey, authDomain, projectId, appId };
}

export function isGoogleSsoConfigured() {
  const cfg = readFirebaseConfig();
  return Boolean(cfg.apiKey && cfg.authDomain && cfg.projectId && cfg.appId);
}

let authInstance = null;

export function getFirebaseAuth() {
  if (!isGoogleSsoConfigured()) {
    throw new Error(
      "Google sign-in is not configured. Set REACT_APP_FIREBASE_* environment variables."
    );
  }
  if (!authInstance) {
    const cfg = readFirebaseConfig();
    const app = getApps().length ? getApps()[0] : initializeApp(cfg);
    authInstance = getAuth(app);
  }
  return authInstance;
}

/**
 * Open Google sign-in popup and return a Firebase ID token for /api/auth/sso/exchange.
 */
export async function signInWithGoogleIdToken() {
  const auth = getFirebaseAuth();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken();
  return {
    idToken,
    email: result.user.email || "",
    displayName: result.user.displayName || "",
  };
}
